import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { Input } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FormInput, FormSelect } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { GLUCOSE_UNIT_OPTIONS } from "./field-constants";
/** Blood-glucose field storing a "low/high" string, with a cosmetic unit. */
export function BloodGlucoseField(_ref) {
  var _field$observation;
  var field = _ref.field,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _String$split = String(value !== null && value !== void 0 ? value : "").split("/"),
    _String$split2 = _slicedToArray(_String$split, 2),
    _String$split2$ = _String$split2[0],
    low = _String$split2$ === void 0 ? "" : _String$split2$,
    _String$split2$2 = _String$split2[1],
    high = _String$split2$2 === void 0 ? "" : _String$split2$2;
  var _useState = useState("mg/dL"),
    unit = _useState[0],
    setUnit = _useState[1];
  var update = function update(part, next) {
    if (next !== "" && !/^[0-9]+$/.test(next)) return;
    var lo = part === "low" ? next : low;
    var hi = part === "high" ? next : high;
    onChange("".concat(lo, "/").concat(hi));
  };
  return /*#__PURE__*/React.createElement(Input.Wrapper, {
    label: t((_field$observation = field.observation) !== null && _field$observation !== void 0 ? _field$observation : "blood_glucose", {
      defaultValue: "Blood glucose"
    }),
    required: field.required
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(FormInput, {
    className: "w-16",
    inputMode: "numeric",
    maxLength: 3,
    placeholder: "--",
    value: low,
    disabled: disabled,
    onChange: function onChange(event) {
      return update("low", event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.GLUCOSE_LOW, {
        fieldId: field.id
      });
    },
    "data-testid": "glucose-low-".concat(field.id)
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-sds-base-secondary"
  }, "/"), /*#__PURE__*/React.createElement(FormInput, {
    className: "w-16",
    inputMode: "numeric",
    maxLength: 3,
    placeholder: "--",
    value: high,
    disabled: disabled,
    onChange: function onChange(event) {
      return update("high", event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.GLUCOSE_HIGH, {
        fieldId: field.id
      });
    },
    "data-testid": "glucose-high-".concat(field.id)
  }), /*#__PURE__*/React.createElement(FormSelect, {
    className: "w-28",
    data: GLUCOSE_UNIT_OPTIONS,
    value: unit,
    onChange: function onChange(next) {
      trackEvent(ANALYTICS_EVENTS.GLUCOSE_UNIT, {
        fieldId: field.id
      });
      setUnit(next !== null && next !== void 0 ? next : "mg/dL");
    },
    disabled: disabled,
    withinPortal: true,
    "data-testid": "glucose-unit-".concat(field.id)
  })));
}